export const ADD_LICENSE = "ADD_LICENSE";
export const ADD_ADVANCE = "ADD_ADVANCE";
export const ADD_PIN = "ADD_PIN";
export const ADD_MANAGER_PIN = "ADD_MANAGER_PIN";
export const ADD_MANAGER_UIDX = "ADD_MANAGER_UIDX";
export const ADD_MANAGER = "ADD_MANAGER";
export const RESET_MANAGER = "RESET_MANAGER";

export const addLicense = (payload) => {
  return { type: ADD_LICENSE, payload };
};

export const addadvance = (payload) => {
  return { type: ADD_ADVANCE, payload };
};

export const addpin = (payload) => {
  return { type: ADD_PIN, payload };
};

export const addmanagerpin = (payload) => {
  return { type: ADD_MANAGER_PIN, payload };
};

export const addmanageruidx = (payload) => {
  return { type: ADD_MANAGER_UIDX, payload };
};

export const addManager = (payload) => {
  return { type: ADD_MANAGER, payload };
};

export const resetManager = () => {
  return { type: RESET_MANAGER };
};
